"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeverageButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../../../common/APLabelWithText"));
var _Button = require("../../../form/Button/Button");
var _useLeverageButton2 = require("./useLeverageButton");
require("./LeverageButton.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('leverage-button');
var LeverageButton = exports.LeverageButton = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var formName = _ref.formName;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var _useLeverageButton = (0, _useLeverageButton2.useLeverageButton)(formName),
    leverage = _useLeverageButton.leverage,
    disabled = _useLeverageButton.disabled,
    noLeverage = _useLeverageButton.noLeverage,
    onClick = _useLeverageButton.onClick;
  return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Leverage'),
    text: /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      disabled: disabled,
      onClick: onClick,
      variant: "secondary",
      size: "sm",
      type: "button"
    }, noLeverage ? t('No Leverage') : "".concat(leverage, "x")),
    customClass: baseClasses()
  });
});
LeverageButton.displayName = 'LeverageButton';